import script from "./GruposEstudanteView.vue?vue&type=script&setup=true&lang=js"
export * from "./GruposEstudanteView.vue?vue&type=script&setup=true&lang=js"

import "./GruposEstudanteView.vue?vue&type=style&index=0&id=2d48d44d&lang=css"

const __exports__ = script;

export default __exports__